import { DocumentFormBuilderComponent } from "./document-form-builder.component";
import { OnInit } from "@angular/core";
import { Claim } from "../../model/claim.model";
import { DocumentField } from "../../model/document-field";
import { ClaimTypes } from "../../model/claim-type.model";
import { SmartqDocuments } from "../../model/smartq-documents.model";
import { UtilitiesService } from "../../utilities/utilities.service";

export class TravelDelayFormBuilder extends DocumentFormBuilderComponent implements OnInit {
    constructor(claim: Claim){
        super(claim);
        this.documentFormClaimType = ClaimTypes[ClaimTypes.CLAIM_TYPE_TDEL];
    }

    setRequiredDocuments(){
        let requiredDocuments: DocumentField[] = [];
        requiredDocuments.push(this.addDocumentWithSTP(new DocumentField('AIRTICKET', 'pageSummaryClaim.claimItem.sectionTD.subSectionSD.copyTicket', SmartqDocuments.AIRTICKET, true), true));
        requiredDocuments.push(this.addDocumentWithSTP(new DocumentField('CARRIERREPORT', 'pageSummaryClaim.claimItem.sectionTD.subSectionSD.rptReason', SmartqDocuments.REPORT, true), true));
        if (['SGP', 'MYS'].indexOf(this.claim.getCountry()) !== -1) {
            requiredDocuments.push(new DocumentField('TRAVELITINERARY', 'pageSummaryClaim.claimItem.sectionTD.subSectionSD.copyTravelIT', SmartqDocuments.AIRTICKET, true));
            if (this.claim.getClaimTravel().getTravelDelay().getHasExtTransCost()) {
                requiredDocuments.push(this.addDocumentWithSTP(new DocumentField('EXTRATRANSCOST', 'pageSummaryClaim.claimItem.sectionTD.subSectionSD.receiptTrans', SmartqDocuments.INVOICE, true), false));
            }
            if (this.claim.getClaimTravel().getTravelDelay().getHasExtAccomCost()) {
                requiredDocuments.push(this.addDocumentWithSTP(new DocumentField('EXTRAACCOMCOST', 'pageSummaryClaim.claimItem.sectionTD.subSectionSD.receiptAccom', SmartqDocuments.INVOICE, true), false));
            }
        } else {
            if (this.claim.getClaimTravel().getTravelDelay().getHasExtTransCost()) {
                requiredDocuments.push(this.addDocumentWithSTP(new DocumentField('RCPTPPAIDTRANS', 'pageSummaryClaim.claimItem.sectionTD.subSectionSD.receiptPrepaidTrans', SmartqDocuments.INVOICE, true), true));
                requiredDocuments.push(this.addDocumentWithSTP(new DocumentField('RCPTPPAIDACCOM', 'pageSummaryClaim.claimItem.sectionTD.subSectionSD.receiptPrepaidAccom', SmartqDocuments.INVOICE, true), true));
            }
            if (this.claim.getClaimTravel().getTravelDelay().getHasExtAccomCost()) {
                requiredDocuments.push(this.addDocumentWithSTP(new DocumentField('RCPTADDTLTRANS', 'pageSummaryClaim.claimItem.sectionTD.subSectionSD.receiptAdditionalTrans', SmartqDocuments.INVOICE, true), true));
                requiredDocuments.push(this.addDocumentWithSTP(new DocumentField('RCPTADDTLACCOM', 'pageSummaryClaim.claimItem.sectionTD.subSectionSD.receiptAdditionalAccom', SmartqDocuments.INVOICE, true), true));
            }
        }
        if (UtilitiesService.checkForMinors(this.claim)) {
            requiredDocuments.push(this.addDocumentWithSTP(new DocumentField('PROOFOFREL', 'pageSummaryClaim.claimItem.miscDoc', SmartqDocuments.LEGALDOCUMENT, true), false));
        }
        this.requiredDocuments = requiredDocuments;
    }
}
